import { render, staticRenderFns } from "./Nutrition.vue?vue&type=template&id=5e43dcda"
import script from "./Nutrition.vue?vue&type=script&lang=js"
export * from "./Nutrition.vue?vue&type=script&lang=js"
import style0 from "./Nutrition.vue?vue&type=style&index=0&id=5e43dcda&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports